import { URLSearchParams } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subscription } from "rxjs";

export default {
  findIndex(items: Array<object>, value: any, key?: string) {
    for (let index = 0; index < items.length; index++) {
      let item = items[index];

      if ((key !== undefined && item[key] == value) || (key === undefined && item == value )) return index;
    }

    return -1;
  },
  find(items: Array<object>, value: any, key?: string) {
    let index = this.findIndex(items, value, key);

    return (index >= 0) ? items[index] : null;
  },
  findChapterIndexByAlias(book, chapterAlias) {
    let chapterIndex = -1;
    for (let i = 0; i < book.chapters.length; i++) {
      let chapter = book.chapters[i];

      if (chapterAlias == chapter.alias) {
        chapterIndex = i;
        break;
      }
    }

    return chapterIndex;
  },
  arrayToObjectMap(array: any[], key?: string): Object {
    let objectMap: Object = {};
    array.forEach(item => objectMap[key || item] = item);

    return objectMap;
  },
  objectMapToArray(object: Object): any[] {
    return Object.keys(object).map(key => object[key]);
  },
  toQueryParams(object: Object): URLSearchParams {
    let queryParams: URLSearchParams = new URLSearchParams();
    if (!object) return queryParams;
    Object.keys(object).forEach(key => queryParams.set(key, object[key]));

    return queryParams;
  },
  toPromise(observable: Observable<any>, name?: string, subscriptions?: Map<string, Subscription>): Promise<any> {
    return new Promise((resolve, reject) => {
      let subscription = observable.subscribe(
        data => resolve(data) && this.clear(name),
        error => reject(error) && this.clear(name)
      );

      if (name && subscriptions) subscriptions.set(name, subscription);
    });
  },
  substringTo(str: string, needle: string): string {
    let index = str.indexOf(needle);
    return (index >= 0) ? str.substring(0, index) : str;
  }
};



// WEBPACK FOOTER //
// ./src/helper.ts